import { useState } from "react";
import "./crop-image.scss";
import { Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import { getCroppedImg } from "../../utility/download-image.utility";

const CropImageModal = ({ show, imageSrc, size, onClose, onSave }) => {

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState<string | null>(null);

    const handleClose = () => {
        onClose();
    }

    const handleZoomChange = (event: Event, newValue: number | number[]) => {
        setZoom(newValue as number);
    };

    const onCropComplete = async (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const handleSave = async () => {
        if (imageSrc) {
            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
            onSave(croppedImage);
        }
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="crop-image-modal">
            <Modal.Body className='crop-image-modal-wrapper'>
                <div className="crop-image-modal-crop-container">
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={size.width / size.height}
                        zoomWithScroll={true}
                        zoomSpeed={1}
                        objectFit="contain"
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}
                    />
                </div>

                <div className="crop-image-modal-footer">
                    <Slider
                        className="crop-image-modal-zoom"
                        min={1}
                        max={3}
                        step={0.1}
                        value={zoom}
                        onChange={handleZoomChange}
                    />

                    <div className="crop-image-modal-action">
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                        >
                            ยกเลิก
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleSave}
                        >
                            ตกลง
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default CropImageModal;